import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e('<g clip-path="url(#a)"><path d="M10.316 2.195a6.25 6.25 0 1 0 3.393 8.347.75.75 0 1 1 1.37.61 7.75 7.75 0 1 1-1.63-8.662l1.02-1.02A.75.75 0 0 1 15.75 2v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.53-1.28l.919-.92a6.25 6.25 0 0 0-2.073-1.355Z"></path><path d="M8.75 5a.75.75 0 1 0-1.5 0v4c0 .284.16.544.415.67l2 1a.75.75 0 1 0 .67-1.34L8.75 8.535V5Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), h = [
  o
];
function p(d, l) {
  return t(), a("svg", c, [...h]);
}
const s = { render: p };
export {
  s as default,
  p as render
};
